import { css } from '@emotion/react';
import { Stack, styled } from '@mui/material';

export const StyledModalStack = styled(Stack)(
  ({ theme }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${theme.palette.background.paper};
    border: 2px solid ${theme.palette.background.paper};
    box-shadow: ${theme.spacing(3)};
    padding: ${theme.spacing(4)};
    height: 90vh;
    overflow: auto;
  `,
);
